import { USER_ROLES } from "@/core/enums/USER_ROLES";
import { PERMISSIONS } from "@/core/enums/PERMISSIONS";

export const ROLES_AND_PERMISSION_ON_ROUTES = {
  ORGANIZATION: {
    ROLES: [
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.FINANCE,
      USER_ROLES.SALES,
    ],
    PERMISSIONS: [],
  },
  FLIGHT_REFUNDS: {
    ROLES: [
      USER_ROLES.OPERATIONS,
      USER_ROLES.SUPER_USER,
      USER_ROLES.AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUB_AGENT,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_REFUND_FLIGHT_TICKET],
  },
  ORGANIZATION_DETAIL: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_USERS],
  },

  EMPLOYEE_GRADE: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_SETUP],
  },
  COST_CENTER: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_SETUP],
  },
  CORPORATE_POLICY: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER, USER_ROLES.OPERATIONS],
    PERMISSIONS: [
      PERMISSIONS.CAN_VIEW_ALL_TRAVEL_POLICIES,
      PERMISSIONS.CAN_MANAGE_ALL_TRAVEL_POLICIES,
    ],
  },
  MY_POLICIES: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.TRAVEL_ADMIN,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.FINANCE_ADMIN,
      USER_ROLES.SUB_AGENT,
    ],
    PERMISSIONS: [],
  },
  DEPARTMENT: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_SETUP],
  },
  APPROVAL_SYSTEM: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER],
    PERMISSIONS: [
      PERMISSIONS.CAN_VIEW_ALL_APPROVAL_WORKFLOWS,
      PERMISSIONS.CAN_MANAGE_ALL_APPROVAL_WORKFLOWS,
    ],
  },
  /** Legacy / shared approval-requests host */
  APPROVAL_REQUESTS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.TRAVEL_ADMIN,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [
      PERMISSIONS.CAN_VIEW_ALL_APPROVAL_REQUESTS,
      PERMISSIONS.CAN_MANAGE_APPROVAL_REQUESTS,
      PERMISSIONS.CAN_OVERRIDE_APPROVAL_REQUESTS,
    ],
  },
  MY_APPROVALS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.TRAVEL_ADMIN,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
      USER_ROLES.FINANCE_ADMIN,
    ],
    PERMISSIONS: [],
  },
  ASSIGNED_APPROVALS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.TRAVEL_ADMIN,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.FINANCE_ADMIN,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_APPROVAL_REQUESTS],
  },
  APPROVAL_DELEGATION: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.TRAVEL_ADMIN,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.FINANCE_ADMIN,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_APPROVAL_REQUESTS],
  },
  PREFERENCE: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_SELF_PREFERENCES],
  },
  WEBSITE_MANAGEMENT: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_SELF_PREFERENCES],
  },
  WHATSAPP_MANAGEMENT: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_SELF_PREFERENCES],
  },
  PASSENGER_MANAGEMENT: {
    ROLES: [
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
      USER_ROLES.AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUB_AGENT,
    ],
    PERMISSIONS: [],
  },
  ORGANIZATION_SNAPSHOT: {
    ROLES: [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.FINANCE,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [],
  },
  SECTOR_SNAPSHOT: {
    ROLES: [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.FINANCE,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [],
  },
  SALES_SNAPSHOT: {
    ROLES: [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.FINANCE,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [],
  },
  DAILY_ISSUANCE: {
    ROLES: [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
    ],
    PERMISSIONS: [],
  },
  CREATE_ORGANIZATION: {
    ROLES: [USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  AGENT_LIST: {
    ROLES: [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.FINANCE,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [],
  },
  AGENT_MANAGEMENT: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_USERS],
  },
  AGENT_PRICING: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_MANAGE_ORGANIZATION_USERS],
  },
  AGENT_PERMISSIONS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [],
  },
  DASHBOARD: {
    ROLES: [],
    PERMISSIONS: [],
  },
  COMPLETE_YOUR_APPLICATION: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [],
  },
  SOA: {
    ROLES: [
      USER_ROLES.FINANCE,
      USER_ROLES.AGENT,
      USER_ROLES.SUPER_USER,
      USER_ROLES.SALES,
      USER_ROLES.OPERATIONS,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_SOA_ITEMS],
  },
  USERPROFILE: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER, USER_ROLES.OPERATIONS],
    PERMISSIONS: [],
  },
  FIT: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_FIT],
  },
  FLIGHTS: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER, USER_ROLES.OPERATIONS],
    PERMISSIONS: [PERMISSIONS.CAN_SEARCH_FLIGHTS],
  },
  FLIGHT_ISSUANCE: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_ISSUE_FLIGHT_TICKET],
  },
  FLIGHTS_BOOKING_FORM: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_BOOK_FLIGHTS],
  },
  HOTELS_BOOKING_DETAILS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ALL_BOOKINGS_OF_HOTEL],
  },
  MY_BOOKINGS: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  MY_ISSUANCES: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  CHURNING: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  MY_ISSUANCES_DETAILS: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  ISSUANCE_LOGS: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  PAYMENTS: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUPER_USER, USER_ROLES.FINANCE],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_SELF_MADE_PAYMENTS],
  },
  DIGITAL_PAYMENTS_BY_SECTORS: {
    ROLES: [USER_ROLES.FINANCE, USER_ROLES.SUPER_USER, USER_ROLES.SUPER_ADMIN],
    PERMISSIONS: [],
  },
  CREATE_PAYMENT: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_CREATE_PAYMENT],
  },
  TUTORIALS: {
    ROLES: [],
    PERMISSIONS: [],
  },
  FDG_FLIGHTS: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_GROUP_FLIGHTS],
  },
  FDG_UMRAH: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_GROUP_TOURS],
  },
  CREDIT_LIMIT_MANAGEMENT: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_CREDIT_LIMIT],
  },
  CREATE_CREDIT_LIMIT_REQUEST: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_REQUEST_CREDIT_LIMIT],
  },
  CREDIT_LIMIT_REQUEST_DETAIL: {
    ROLES: [USER_ROLES.SALES],
    PERMISSIONS: [],
  },
  HOTELS: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_SEARCH_HOTEL],
  },
  SABRE_SEGMENT: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_USER_PRICING],
  },
  NEWS: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUB_AGENT],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_USER_NEWS],
  },
  FARE_MANAGEMENT: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_ISSUE_FLIGHT_TICKET],
  },
  PRICING: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_USER,
    ],
    PERMISSIONS: [PERMISSIONS.CAN_VIEW_ORGANIZATION_USER_PRICING],
  },
  Error403: {
    ROLES: [],
    PERMISSIONS: [],
  },
  Error404: {
    ROLES: [],
    PERMISSIONS: [],
  },
  MANAGE_QUOTATIONS: {
    ROLES: [
      USER_ROLES.AGENT,
      USER_ROLES.SUB_AGENT,
      USER_ROLES.EMPLOYEE,
      USER_ROLES.SUPER_USER,
      USER_ROLES.OPERATIONS,
      USER_ROLES.SALES,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.MANAGEMENT,
    ],
    PERMISSIONS: [],
  },
  CURRENCY_CONVERSION: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SALES, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  SALES_MY_TEAM: {
    ROLES: [USER_ROLES.SALES],
    PERMISSIONS: [],
  },
  ORGANIZATION_DOCUMENTS: {
    ROLES: [USER_ROLES.AGENT],
    PERMISSIONS: [],
  },
  SAAS_ORGANIZATIONS: {
    ROLES: [USER_ROLES.FINANCE, USER_ROLES.SUPER_USER, USER_ROLES.OPERATIONS],
    PERMISSIONS: [],
  },
  MANAGE_PRICING: {
    ROLES: [USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  DEALS_AND_PROMOS: {
    ROLES: [USER_ROLES.AGENT, USER_ROLES.SUB_AGENT, USER_ROLES.EMPLOYEE],
    PERMISSIONS: [],
  },
  VISA_VERIFICATION: {
    ROLES: [USER_ROLES.OPERATIONS, USER_ROLES.SUPER_USER],
    PERMISSIONS: [],
  },
  GROUPS: {
    ROLES: [],
    PERMISSIONS: [],
  },
};
